export default __webpack_public_path__ + "static/media/arb_black.7f887a51.svg";